var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoNotice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1142",
    "data-name": "\\uADF8\\uB8F9 1142",
    transform: "translate(-1868 -654)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "free-icon-font-comment-alt-3916599",
    transform: "translate(1870 656)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_816",
    "data-name": "\\uD328\\uC2A4 816",
    d: "M16.667,0H3.333A3.333,3.333,0,0,0,0,3.333v10a3.333,3.333,0,0,0,3.333,3.333H5.75L9.459,19.8a.833.833,0,0,0,1.077,0l3.714-3.136h2.417A3.333,3.333,0,0,0,20,13.333v-10A3.333,3.333,0,0,0,16.667,0Zm1.667,13.333A1.667,1.667,0,0,1,16.667,15H14.25a1.667,1.667,0,0,0-1.076.394L10,18.075,6.827,15.394h0A1.667,1.667,0,0,0,5.75,15H3.333a1.667,1.667,0,0,1-1.667-1.667v-10A1.667,1.667,0,0,1,3.333,1.667H16.667a1.667,1.667,0,0,1,1.667,1.667Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_817",
    "data-name": "\\uD328\\uC2A4 817",
    d: "M7,7h5a1,1,0,0,0,0-2H7A1,1,0,0,0,7,7Z",
    transform: "translate(-1.412 -0.909)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_818",
    "data-name": "\\uD328\\uC2A4 818",
    d: "M17,9H7a1,1,0,0,0,0,2H17a1,1,0,0,0,0-2Z",
    transform: "translate(-2 -1.636)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_819",
    "data-name": "\\uD328\\uC2A4 819",
    d: "M17,13H7a1,1,0,0,0,0,2H17a1,1,0,0,0,0-2Z",
    transform: "translate(-2 -2.364)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1137",
    "data-name": "\\uADF8\\uB8F9 1137",
    transform: "translate(-4633 888)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_129",
    "data-name": "\\uC0AC\\uAC01\\uD615 129",
    width: 24,
    height: 24,
    transform: "translate(6501 -234)",
    fill: "none",
    opacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNotice);
export default __webpack_public_path__ + "static/media/ico_notice.1bbd7defa566e10ba80e2932acbb69c1.svg";
export { ForwardRef as ReactComponent };